/**
 * Bus d'événements minimal pour déclencher l'ouverture du modal de rotation
 * de clé bootstrap. Découple l'intercepteur Axios (qui tourne dans la couche
 * data) du cycle React (qui gère le rendu du modal).
 *
 * - `setRotationGateHandler` est appelé par RotationGateProvider au mount
 *   pour s'enregistrer comme listener.
 * - `triggerRotationGate` est appelé par l'intercepteur Axios sur 403 depuis
 *   un endpoint "bootstrap-pending" (profile, balance).
 *
 * Si aucun handler n'est enregistré (provider absent / non monté), l'appel
 * est silencieusement ignoré — pas de crash.
 */

type RotationGateHandler = () => void;

let handler: RotationGateHandler | null = null;

export function setRotationGateHandler(
  next: RotationGateHandler | null,
): void {
  handler = next;
}

export function triggerRotationGate(): void {
  if (handler) {
    handler();
  }
}